import React from 'react';
import PropTypes from 'prop-types';

const RemovePath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M20.142 15.9l6.364 6.363a1 1 0 0 1 0 1.415l-2.828 2.828a1 1 0 0 1-1.415 0L15.9 20.142l-6.363 6.364a1 1 0 0 1-1.415 0l-2.828-2.828a1 1 0 0 1 0-1.415l6.364-6.364-6.364-6.363a1 1 0 0 1 0-1.415L8.12 5.293a1 1 0 0 1 1.415 0l6.363 6.364 6.364-6.364a1 1 0 0 1 1.415 0l2.828 2.828a1 1 0 0 1 0 1.415l-6.364 6.363z"
    />
  );
};

RemovePath.propTypes = {
  fill: PropTypes.string,
};

export default RemovePath;



// WEBPACK FOOTER //
// ./src/icon/svgs/interaction/remove.jsx